import React, { useState } from 'react';
import BubbleInput from 'ps-components/BubbleInput/BubbleInput';
import { func, bool, array, object } from 'prop-types';

import './SelectExistingStructures.scss';

SelectExistingStructures.propTypes = {
  strucList: array,
  structures: array,
  setStructures: func,
  allStructures: bool,
  setAllStructures: func
};

export default function SelectExistingStructures(props) {
  const { strucList, structures, setStructures, allStructures, setAllStructures } = props;
  const [focused, setFocused] = useState(false);
  function setAllStructuresTrue() {
    setAllStructures(true);
  }

  function setAllStructuresFalse() {
    setAllStructures(false);
  }

  function handleFocus() {
    setFocused(true);
  }

  function handleBlur() {
    setFocused(false);
  }

  if (strucList.length === 0)
    return <div className="select-existing-structures__no-structures-text">There are no structures to select.</div>;

  const dropdownOptions = strucList
    ? strucList
        .filter(struc => !structures.find(strucObj => strucObj.value.code === struc.code))
        .map(struc => {
          return {
            label: `${struc.code} (${struc.currency})`,
            value: struc
          };
        })
    : [];

  return (
    <div className="pxl-options select-existing-structures">
      <label className="pxl-option pxl-option--radio pxl-option--primary">
        <input
          type="checkbox"
          checked={!allStructures}
          onChange={setAllStructuresFalse}
          onFocus={handleFocus}
          onBlur={handleBlur}
          className="pxl-option__input"
        />
        <div className="pxl-option__text">
          <span>
            Select one or more structures
            {!allStructures && <span className="label-subtext">type to search for a specific structure</span>}
          </span>
          {!allStructures && (
            <BubbleInput
              className="structure-select__bubble-input"
              bubbles={structures}
              setBubbles={setStructures}
              dropdownOptions={dropdownOptions}
              onFocus={setAllStructuresFalse}
              hideInputLabel={true}
              passFocus={focused}
            />
          )}
        </div>
      </label>
      <label className="pxl-option pxl-option--radio pxl-option--primary">
        <input type="checkbox" checked={allStructures} onChange={setAllStructuresTrue} className="pxl-option__input" />
        <div className="pxl-option__text">
          <span>Select all {strucList.length} existing structures</span>
        </div>
      </label>
    </div>
  );
}
